import { render, staticRenderFns } from "./SexRank.vue?vue&type=template&id=0a171322&scoped=true&lang=true&"
import script from "./SexRank.vue?vue&type=script&lang=js&"
export * from "./SexRank.vue?vue&type=script&lang=js&"
import style0 from "./SexRank.vue?vue&type=style&index=0&id=0a171322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a171322",
  null
  
)

export default component.exports